export default function Footer() {
  return (
    <footer className="bg-salon-light border-t border-gold/20 py-12 sm:py-14">
      <div className="max-w-6xl mx-auto px-6 sm:px-8">
        {/* Top: logo + info */}
        <div className="flex flex-col sm:flex-row items-center sm:items-start justify-between gap-8 mb-8 pb-8 border-b border-charcoal/10">
          {/* Logo + name */}
          <div className="flex flex-col items-center sm:items-start gap-3">
            <img
              src="https://public.readdy.ai/ai/img_res/9c6f8245-9b62-4527-89bf-39db6d8d45df.png"
              alt="サロンロゴ"
              className="h-10 w-auto object-contain"
              style={{ filter: 'brightness(0.4)' }}
            />
            <p className="font-sans-jp text-salon-gray text-center sm:text-left" style={{ fontSize: '12px', lineHeight: '1.8' }}>
              〒150-0001 東京都渋谷区神宮前 3-12-5 渋谷ハウス 2F
              <br />
              TEL: 03-1234-5678　／　営業時間: 10:00〜20:00
            </p>
          </div>

          {/* Nav links */}
          <nav className="flex flex-wrap justify-center sm:justify-end gap-6">
            {[
              { label: 'メニュー', href: '#menu' },
              { label: '設備・安全', href: '#facilities' },
              { label: 'アクセス', href: '#access' },
              { label: 'ご予約', href: '#booking' },
            ].map((link) => (
              <a
                key={link.label}
                href={link.href}
                className="font-sans-jp text-salon-gray hover:text-gold transition-colors duration-300 cursor-pointer"
                style={{ fontSize: '13px', letterSpacing: '0.08em' }}
              >
                {link.label}
              </a>
            ))}
          </nav>
        </div>

        {/* Bottom: copyright */}
        <div className="text-center">
          <p className="font-sans-jp text-salon-gray" style={{ fontSize: '11px', letterSpacing: '0.1em' }}>
            &copy; {new Date().getFullYear()} Private Beauty Salon. All Rights Reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
